<template>
  <pui-hot-module-layout
    id="layout-dam"
    :theme="damTheme"
    :appAlias="DAM_APP_NAME"
    @loadingChange="initNotificationsReference"
    class="pui-home pui-wrapper"
  >
    <pui-header>
      <template #logo>
        <router-link :to="{ name: 'applications' }" class="logo-link dam">
          <pui-image :src="damLogo" class="logo-img" alt="DAM" />
        </router-link>
      </template>

      <pui-flex justifyContent="end" class="added-button-list-container">
        <pui-sidebar>
          <pui-sidebar-item
            :text="$t('dam.header.dashboard')"
            :to="{ name: 'damDashboard' }"
            picto="mdi-gauge"
          />
          <pui-header-button
            v-permission="CommonPermissions.UploadCreate"
            @click="openImportDialog"
            picto="mdi-download"
          >
            {{ $t('dam.header.import') }}
          </pui-header-button>
          <pui-sidebar-item
            :text="$t('dam.header.assets')"
            :to="{ name: 'damAssets' }"
            picto="mdi-camera"
          />
          <pui-header-button-separator />
          <pui-badge
            :content="notifications.length ? notifications.length : ''"
            :bgColor="notifications.length ? 'var(--color-error-background)' : `'initial'`"
            color="var(--color-initial)"
            offsetX="38px"
            offsetY="20px"
          >
            <pui-header-button ref="notifButtonRefernce" picto="mdi-bell">
              {{ $t('dam.header.notifications') }}
            </pui-header-button>
          </pui-badge>
        </pui-sidebar>
      </pui-flex>
    </pui-header>
    <div id="pui-app-main">
      <div id="pui-app-content">
        <router-view />
      </div>
    </div>
    <pui-message-box-container>
      <pui-common-message-box
        v-for="alert in alerts"
        :key="alert.id"
        :model="alert"
        :queuedCount="queuedAlertsCount"
        @close="closeAlert"
        @click.stop="openNotifications"
      />
    </pui-message-box-container>

    <template v-if="notificationsReference">
      <pui-notifications
        ref="notifications"
        :customReference="notificationsReference"
        updateOnCreate
      />
    </template>
  </pui-hot-module-layout>
</template>
<script>
import { mapGetters } from 'vuex';

import services from '../../../core/services';
import { NotificationEvents } from '../../../platform/constants/notifications';
import { CommonPermissions } from '../../common/constants/permissions';
import { DAM_APP_NAME, DAM_SERVICES_NAMESPACE } from '../constants';
import { FileUploadEvents } from '../constants/file';
import damLogo from '../static/img/dam-logo.svg';
import damTheme from '../theme';

export default {
  provide: {
    dialogSelector: '#layout-dam',
  },
  data() {
    return {
      notificationsReference: null,
      damLogo,
      damTheme,
      DAM_APP_NAME,
      CommonPermissions,
    };
  },
  computed: {
    ...mapGetters({
      alerts: 'alerts',
      queuedAlertsCount: 'queuedAlertsCount',
      notifications: 'notifications',
    }),
  },
  methods: {
    /**
     * Opens the asset import dialog
     *
     * @returns {void}
     */
    openImportDialog() {
      // Assume that components that will listen to the event are
      // mounted and can react
      services.getService('uploadManager').$emit(FileUploadEvents.OPEN_FILE_UPLOAD_DIALOG);
    },
    /**
     * Initialiezs the notifications reference
     */
    async initNotificationsReference() {
      await this.$nextTick();
      const notifButton = this.$refs.notifButtonRefernce;
      if (notifButton) {
        this.notificationsReference = notifButton.$el;
      } else {
        this.notificationsReference = null;
      }
    },
    /**
     * Closes the alert message
     *
     * @param {Number} alertId - the id of the alert to close
     */
    closeAlert(alertId) {
      services.getService('alerts').clearAlert(alertId);
    },
    /**
     * Opens the notifications
     *
     * @returns {void}
     */
    openNotifications() {
      this.$refs.notifications.open();
    },
  },
  /**
   * Initializes module
   */
  beforeCreate() {
    services.onModuleBeforeCreate(DAM_APP_NAME, DAM_SERVICES_NAMESPACE);
  },
  /**
   * Initializes variables on mount
   */
  mounted() {
    this.initNotificationsReference();

    services
      .getService('notifications')
      .$on(NotificationEvents.OPEN_NOTIFICATIONS, this.openNotifications);
  },
  beforeDestroy() {
    services.onModuleBeforeDestroyed(DAM_APP_NAME, DAM_SERVICES_NAMESPACE);

    services
      .getService('notifications')
      .$off(NotificationEvents.OPEN_NOTIFICATIONS, this.openNotifications);
  },
};
</script>
